const ReviewTradingPhotoCardSkeleton = () => {
  return (
    <div className="flex flex-col items-center gap-[16px]">
      {[...Array(2)].map((_, index) => (
        <div
          key={index}
          className="w-[327px] h-[167px] rounded-[20px] bg-gray-200 dark:bg-gray-700 animate-pulse"
        />
      ))}
    </div>
  );
};

export default ReviewTradingPhotoCardSkeleton;
